import React, { Fragment, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getAtkvaediByKennitala } from "common/services/apiService";
import { AppContext } from "store/AppContext";


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  loadingWrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

export default function AtkvaediLookup(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { setData } = props;
  const [kennitala, setKennitala] = useState("");
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = e => {
    setKennitala(e.target.value.replace(/\D/, ''));
  }

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const validate = () => {
    if (kennitala === "") {
      setIsError(true);
      setErrorMsg("Nauðsynlegt er að slá inn kennitölu");
      return false;
    }

    return true;
  };

  async function handleSubmit() {
    if (!validate()) return;
    
    setLoading(true);
    
    const { data, httpStatus, isSuccess, error } = await getAtkvaediByKennitala(
      kennitala,
      context,
      []
    );

    if (isSuccess) {
      setData(data);
      setLoading(false);
      setIsError(false);
    } else {
      setLoading(false);
      setIsError(true);
      if (httpStatus === 400) {
        setErrorMsg(error.title);
      } else {
        setErrorMsg(`Óvænt villa kom upp: ${error}`);

      }
    }
  }

  return (
    <Fragment>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4">Kennitala kjósanda</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="input-kennitala"
              label="Kennitala"
              value={kennitala}
              inputProps={{ maxLength: 10 }}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              autoComplete="off"
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            {isError && (
              <div>
                <Typography color="error">{errorMsg}</Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <div className={classes.loadingWrapper}>
              <Button
                color="primary"
                variant="contained"
                disabled={loading}
                onClick={handleSubmit}
              >
                Áfram
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
}
